import type { UserType } from '~/types/responses';

import isProd from './isProd';

/**
 * Production pilot for the Hero Planner "Regenerate tail deals" button: only these `id_member` UUIDs see it, on top of
 * the hero-planner-admin role the backend requires. Staging/non-prod: every hero-planner-admin sees it.
 */
export const HERO_PLANNER_TAIL_DEAL_REGENERATION_ALLOWED_MEMBER_IDS_PROD: ReadonlyArray<string> = [
  '448cb507-7c1a-456f-beb9-204a3bf5bd84',
  '201ee013-e557-4635-bd47-442a828108b7',
  'e195455c-c72b-4a86-8d05-bbb1c9746e2f',
  '3d29617f-01fa-4847-84f2-305c3888d063',
];

const allowedInProd = new Set(
  HERO_PLANNER_TAIL_DEAL_REGENERATION_ALLOWED_MEMBER_IDS_PROD.map((id) => id.toLowerCase()),
);

export function canRegenerateHeroPlannerTailDeals(user: UserType | null | undefined): boolean {
  if (!user?.id_member) {
    return false;
  }

  if (!isProd()) {
    return true;
  }

  return allowedInProd.has(user.id_member.toLowerCase());
}
